import { t } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";

import { emitNotificationOnQueryParam } from "utils/notification";

export const NOTIFICATION_TYPE = {
    COLLECT_COMPLETED: "CollectCompleted",
    COLLECT_ALREADY_COMPLETE: "CollectAlreadyComplete",
    COLLECT_ARCHIVED: "CollectArchived",
    COLLECT_SAVED: "CollectSaved",
    REVIEW_REJECTED: "ReviewRejected",
    REVIEW_APPROVED: "ReviewApproved",
    REVIEW_ALREADY_COMPLETE: "ReviewAlreadyComplete",
    REVIEW_CONTROL_NOT_COMPLETED_YET: "ReviewControlNotCompletedYet",
    REVIEW_ARCHIVED: "ReviewArchived",
    REVIEW_SAVED: "ReviewSaved",
} as const;

export type NotificationType =
    (typeof NOTIFICATION_TYPE)[keyof typeof NOTIFICATION_TYPE];

export const notificationTypes: NotificationType[] = [
    NOTIFICATION_TYPE.COLLECT_COMPLETED,
    NOTIFICATION_TYPE.COLLECT_ALREADY_COMPLETE,
    NOTIFICATION_TYPE.COLLECT_ARCHIVED,
    NOTIFICATION_TYPE.COLLECT_SAVED,
    NOTIFICATION_TYPE.REVIEW_REJECTED,
    NOTIFICATION_TYPE.REVIEW_APPROVED,
    NOTIFICATION_TYPE.REVIEW_ALREADY_COMPLETE,
    NOTIFICATION_TYPE.REVIEW_CONTROL_NOT_COMPLETED_YET,
    NOTIFICATION_TYPE.REVIEW_ARCHIVED,
    NOTIFICATION_TYPE.REVIEW_SAVED,
];

export function handleNotifications() {
    notificationTypes.forEach((type) => {
        let message: string;
        let level: "success" | "warning";

        switch (type) {
            case NOTIFICATION_TYPE.COLLECT_COMPLETED:
                message = t("CollectControlResult_Completed_Title");
                level = "success";
                break;
            case NOTIFICATION_TYPE.COLLECT_ALREADY_COMPLETE:
                message = t("CollectControlResult_AlreadyCompleted_Title");
                level = "warning";
                break;
            case NOTIFICATION_TYPE.COLLECT_ARCHIVED:
                message = t("CollectControlResult_Archived_Title");
                level = "warning";
                break;
            case NOTIFICATION_TYPE.COLLECT_SAVED:
                message = t("Dashboard_PendingActions_CollectSaved");
                level = "success";
                break;
            case NOTIFICATION_TYPE.REVIEW_REJECTED:
                message =
                    t("ReviewResult_Rejected_Title") +
                    " - " +
                    t("ReviewResult_Rejected_Description");
                level = "success";
                break;
            case NOTIFICATION_TYPE.REVIEW_APPROVED:
                message = t("ReviewResult_Approved_Title");
                level = "success";
                break;
            case NOTIFICATION_TYPE.REVIEW_ALREADY_COMPLETE:
                message = t("ReviewResult_AlreadyCompleted_Title");
                level = "warning";
                break;
            case NOTIFICATION_TYPE.REVIEW_CONTROL_NOT_COMPLETED_YET:
                message = t("ReviewResult_ControlNotCompletedYet_Title");
                level = "warning";
                break;
            case NOTIFICATION_TYPE.REVIEW_ARCHIVED:
                message =
                    t("ReviewResult_Archived_Title") +
                    " - " +
                    t("ReviewResult_Archived_Description");
                level = "warning";
                break;
            case NOTIFICATION_TYPE.REVIEW_SAVED:
                message = t("Dashboard_PendingActions_ReviewSaved");
                level = "success";
                break;
            default:
                assertNever(type);
        }

        emitNotificationOnQueryParam(type, "True", message, level);
    });
}
